import { IReduxStore } from "Redux/Store/IReduxStore";

export const getActiveLanguage = (state: IReduxStore) => state.persist.activeLanguage;